import {
  borderRadius,
  customScrollMinimal,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const Separator = styled.div`
  width: 100%;
  display: flex;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ScrollableContainer = styled.div`
  flex: 1;
  max-height: calc(100vh - 262px);
  overflow-y: auto;
  scroll-behavior: smooth;
  max-width: 764px;
  width: 100%;
  ${customScrollMinimal};
  display: flex;
  flex-direction: column;
  gap: 60px;
  border-right: none;
`;

export const EarningsReleaseDate = styled.div`
  display: flex;
  padding: 8px 12px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  align-self: stretch;
  ${borderRadius.r2};
  background: var(--surface-default);
  margin-bottom: 30px;
`;

export const DateWrapper = styled.div`
  display: flex;
  gap: 5px;
`;

export const Date = styled.div`
  color: var(--text-soft);
  ${typographyV2.titleSm};
`;
export const Span = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-default);
`;

export const TextSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 44px;
`;

export const Section = styled.div`
  box-sizing: border-box;
`;
